import { render, staticRenderFns } from "./handispot.vue?vue&type=template&id=1db9fa5e&"
import script from "./handispot.vue?vue&type=script&lang=ts&"
export * from "./handispot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports